
<template>
    <v-overlay :value="isLoading" opacity="0.6" style="z-index: 9999">
        <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
</template>

<script>
import { EventBus } from '@/event-bus'

export default {
    data() {
        return {
            isLoading: false
      }
    },
    created() {
        EventBus.$on('show-loading', this.show)
        EventBus.$on('hide-loading', this.hide)
    },
    beforeDestroy() {
        EventBus.$off('show-loading', this.show)
        EventBus.$off('hide-loading', this.hide)
    },
    methods: {
        show() {
            this.isLoading = true
        },
        hide() {
            this.isLoading = false
        }
    }
}
</script>
